import { useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

// material-ui
import { Box, Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// third-party
import { useAuthenticator } from '@aws-amplify/ui-react';

// project imports
import getCurrentToken from 'utils/getCurrentToken';

// assets
import { IconLogout } from '@tabler/icons';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
  const customization = useSelector((state) => state.customization);
  const dispatch = useDispatch();
  const theme = useTheme();
  const { signOut } = useAuthenticator((context) => [context.signOut]);
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const token = await getCurrentToken();
        setUser(token.payload['email']);
        setRole(...token.payload['cognito:groups']);
      } catch (error) {
        console.error(error);
      }
    };

    fetchRole();
  }, []);

  const handleSignOut = async () => {
    try {
      dispatch({ type: 'LOGOUT' });
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <Box sx={{ display: 'inline-flex' }}>
      <Stack sx={{ justifyContent: 'flex-end', mr: 2 }}>
        <Stack direction="row" spacing={0.5} alignItems="left">
          <Typography variant="h5">ユーザー: </Typography>
          <Typography component="span" variant="h5" sx={{ fontWeight: 400 }}>
            {user}
          </Typography>
        </Stack>
        <Typography variant="subtitle2">グループ: {role}</Typography>
      </Stack>
      <Button
        variant="outlined"
        endIcon={<IconLogout stroke={1.5} size="1.3rem" />}
        sx={{
          borderRadius: `${customization.borderRadius}px`,
          justifyContent: 'flex-end',
          color: 'secondary.dark',
          borderColor: 'secondary.dark',
          '&:hover': {
            background: theme.palette.secondary.dark,
            color: theme.palette.secondary.light,
            borderColor: theme.palette.secondary.dark
          }
        }}
        onClick={handleSignOut}
      >
        ログアウト
      </Button>
    </Box>
  );
};

export default ProfileSection;
